import { PageIds } from '@bupa-kkv/features/company-creation/types';
import { companyCreationAxiosInstance } from '@bupa-monorepo/shared-frontend/admin/shared';
import { IPageConfiguration } from '@bupa-monorepo/shared-types/page-configuration-types';

export const fetchConfiguration = async (
  pageId: keyof typeof PageIds
): Promise<IPageConfiguration> =>
  (
    await companyCreationAxiosInstance.get(
      `v1/customer/configurablePages/${PageIds[pageId]}/pageConfiguration`
    )
  ).data;
